wbApp.factory('courseRegistrationSvc', ['$resource', '$q', '$translate', '$filter', 'notificationSvc', 'repositorySvc', 'courseScheduleSvc', 'invoiceSvc', 'promotionSvc', 'attendanceSvc', 'coursePriceSvc', 'courseSvc',
    function ($resource, $q, $translate, $filter, notificationSvc, repositorySvc, courseScheduleSvc, invoiceSvc, promotionSvc, attendanceSvc, coursePriceSvc, courseSvc) {

        var CourseRegistrations = $resource('/Api/CourseRegistrations/Get', {}, {
            'getAllForCourse': { method: 'GET', isArray: true, url: '/Api/CourseRegistrations/Get' },
            'getAllForCourseAndUser': { method: 'GET', isArray: true, url: '/Api/CourseRegistrations/GetAllByCourseAndUser' },
            'getAllCoursesByStudent': { method: 'GET', isArray: true, url: '/Api/CourseRegistrations/GetAllCoursesByStudent' },
            'getAllActionsByStudent': { method: 'GET', isArray: true, url: '/Api/CourseRegistrations/GetAllActionsByStudent' },
            'getAllCoursesByUser': { method: 'GET', isArray: true, url: '/Api/CourseRegistrations/GetAllCoursesByUser' },
            'getAllActionsByUser': { method: 'GET', isArray: true, url: '/Api/CourseRegistrations/getAllActionsByUser' },
            'getByRegistrationId': { method: 'GET', isArray: false, url: '/Api/CourseRegistrations/GetByRegistrationId'},
            'getInfoFromCourseRegistrationBarcode': { method: 'GET', isArray: false, url: '/Api/CourseRegistrations/GetInfoFromCourseRegistrationBarcode'},
            'sendRegistrationNotification': { method: 'POST', url: '/Api/CourseRegistrations/SendRegistrationNotification' },
            'createFullCourseInterest': { method: 'POST', url: '/restapi/course-registrations/full-course-interest' },
            'update': { method: 'POST', url: '/Api/CourseRegistrations/Update' },
            'insert': { method: 'POST', url: '/Api/CourseRegistrations/Insert' },
            'insertAll': { method: 'POST', url: '/Api/CourseRegistrations/InsertAll' },
            'delete': { method: 'POST', url: '/Api/CourseRegistrations/Delete' },
            'calcExpectedDueDate': { method: 'POST', url: '/Api/CourseRegistrations/CalcExpectedDueDate' },
            'getCourseInterestById': { method: 'GET', isArray: false, url: '/restapi/course-interests/:id'},
        });

        function getCourseInterestById(id) {
            return repositorySvc.customGet('getCourseInterestById', CourseRegistrations, { id: id });
        }

        function createNew(course, isAction, doNotPreselect) {
            var newReg = new webooker_courses_models.CourseRegistration({});
            return newReg.preInitNew($q, courseScheduleSvc, course, isAction, doNotPreselect);
        }

        function initializeModel(model, course, isAction, isAdmin, doNotPreselect) {
            return model.initialize($q, invoiceSvc, promotionSvc, attendanceSvc, coursePriceSvc,
                course, isAction, isAdmin, doNotPreselect);
        }

        // Appends user schedule model to list of course registrations, used for free places calculations
        // for the whole user
        // Returns promise 
        function appendScheduleModel(
            courseRegistrations, /* array of course registrations enriched by extendModelWithDetails */
            courseID,
            refresh /* reload schedules */) {
            return $q(function (resolve, reject) {
                var userSchedules = [];

                // all attendance objects from each courseRegistration in courseRegistrations array
                var allAttendanceArray = [];
                _.forEach(courseRegistrations, function (cr) {
                    allAttendanceArray.push.apply(allAttendanceArray, cr.registeredAttendance);
                });
                var allAttendanceMap = _.groupBy(allAttendanceArray, 'courseScheduleID');

                courseScheduleSvc.getAllAsync(courseID, refresh).$promise.then(
                    function (schedules) {
                        _.forEach(schedules, function (schedule) {
                            var userSchedule = new webooker_courses_models.CourseRegistrationUserSchedule(schedule);

                            var attendance = allAttendanceMap[schedule.courseScheduleID];
                            userSchedule.addCourseRegistrationAttendance.call(userSchedule, attendance || []);

                            userSchedules.push(userSchedule);
                        });
                        resolve(userSchedules);
                    }, reject);
            });
        }

        function refreshSchedules(
            courseRegistrations, /* array of course registrations enriched by extendModelWithDetails */
            courseID) {

            return $q(function (resolve, reject) {

                courseScheduleSvc.getAllAsync(courseID, true).$promise.then(
                    function (schedules) {

                        _.forEach(courseRegistrations, function (courseRegistration) {
                            courseRegistration.updateCapacityByRefreshedSchedules.call(courseRegistration, schedules);
                        });

                        resolve(courseRegistrations);
                    }, reject);
            });
        }

        function updateReservedPlaces(model, reservedPlaces) {
            angular.forEach(model.registeredAttendance, function (ra) {
                ra.attendanceCount = reservedPlaces;
            });
        }

        function extendRegistrations(data, result) {
            angular.forEach(data, function (registration) {

                var futureAttendance = _.filter(registration.registeredAttendance, function (o) {
                    return moment().isBefore(o.startDate);
                });

                registration.noFurtherRegisteredAttendance =
                    _.every(futureAttendance, { courseAttendanceType: null }) && futureAttendance.length > 0;

                if (registration.registeredAttendance && registration.registeredAttendance.length === 1) {
                    registration.attendanceStatusText = $filter('attendanceStatus')(registration.registeredAttendance[0].courseAttendanceStatus);

                    registration.attendanceStatusNotPresent = !!registration.registeredAttendance[0].courseAttendanceStatus;
                } else {
                    registration.attendanceStatusText = "";
                    registration.attendanceStatusNotPresent = true;
                }

                result.push(registration);
            });
        }

        // Client
        function getAllForCourseAndUser(userID, course, students, isAction, includeInterestsAsVirtual, doNotPreselect) {
            var deferred = $q.defer();
            var result = [];

            repositorySvc.customGet('getAllForCourseAndUser', CourseRegistrations, {
                courseID: course.courseID,
                userID: userID,
                includeInterestsAsVirtual: includeInterestsAsVirtual
            }).$promise.then(function (data) {
                var newRegPromises = [];

                angular.forEach(students, function (student) {                     
                    if (!_.find(data, { studentID: student.id })) {
                        var reg = createNew(course, isAction, doNotPreselect);
                        reg.then(function (st) {
                            st.studentID = student.id;
                            st.parentID = student.userID;
                            st.studentFullName = student.fullName;
                            st.studentAge = student.age;
                            st.studentBirthday = student.birthday;
                        });
                        newRegPromises.push(reg);
                    }                                        
                });

                var resPromisses = [];

                if (newRegPromises.length) {
                    $q.all(newRegPromises).then(function (newRegPromisesResolved) {
                       
                        _.forEach(newRegPromisesResolved, function (newReg) {
                            var newRegModel = new webooker_courses_models.CourseRegistration(newReg);

                            resPromisses.push(newRegModel.initialize.call(newRegModel, $q, invoiceSvc, promotionSvc, attendanceSvc, coursePriceSvc, 
                                course, isAction, false, doNotPreselect));
                        });
                        
                        _.forEach(data, function (registration) {
                            var regModel = new webooker_courses_models.CourseRegistration(registration);

                            resPromisses.push(regModel.initialize.call(regModel, $q, invoiceSvc, promotionSvc, attendanceSvc, coursePriceSvc,
                                course, isAction, false, doNotPreselect));
                        });
                        
                        $q.all(resPromisses).then(function (r) {                            
                            if (course.allowClientLessonSelection) {
                                appendScheduleModel(r, course.courseID, false).then(function () {
                                    extendRegistrations(_.sortBy(r, 'studentFullName'), result);
                                    deferred.resolve(result);
                                }, function (errorResult) { deferred.reject(errorResult); });
                            } else {
                                extendRegistrations(_.sortBy(r, 'studentFullName'), result);
                                deferred.resolve(result);
                            }
                        });
                    });
                } else {
                    _.forEach(data, function (registration) {
                        var regModel = new webooker_courses_models.CourseRegistration(registration);

                        resPromisses.push(regModel.initialize.call(regModel, $q, invoiceSvc, promotionSvc, attendanceSvc, coursePriceSvc,
                            course, isAction, false, doNotPreselect));
                    });

                    $q.all(resPromisses).then(function (r) {

                        if (course.allowClientLessonSelection) {
                            appendScheduleModel(r, course.courseID, false).then(function () {
                                extendRegistrations(_.sortBy(r, 'studentFullName'), result);
                                deferred.resolve(result);
                            }, function (errorResult) { deferred.reject(errorResult); });
                        } else {
                            extendRegistrations(_.sortBy(r, 'studentFullName'), result);
                            deferred.resolve(result);
                        }
                    });
                }
            }, function (errorResult) {
                deferred.reject(errorResult);
            });

            result.$promise = deferred.promise;
            return result;
        }

        function getAllForCourse(courseID) {
            var deferred = $q.defer();
            var result = [];

            repositorySvc.customGet('getAllForCourse', CourseRegistrations, {
                courseID: courseID
            }).$promise.then(function (data) {
                extendRegistrations(data, result);
                deferred.resolve(result);
            }, function (errorResult) {
                deferred.reject(errorResult);
            });

            result.$promise = deferred.promise;
            return result;
        }

        function getAllCoursesByStudent(studentID) {
            return repositorySvc.customGet('getAllCoursesByStudent', CourseRegistrations, {
                studentID: studentID
            });
        }

        function getAllActionsByStudent(studentID) {
            return repositorySvc.customGet('getAllActionsByStudent', CourseRegistrations, {
                studentID: studentID
            });
        }

        function getAllCoursesByUser(userID) {
            return repositorySvc.customGet('getAllCoursesByUser', CourseRegistrations, {
                userID: userID
            });
        }

        function getAllActionsByUser(userID) {
            return repositorySvc.customGet('getAllActionsByUser', CourseRegistrations, {
                userID: userID
            });
        }
        
        function getInfoFromCourseRegistrationBarcode(code) {
            return repositorySvc.customGet('getInfoFromCourseRegistrationBarcode', CourseRegistrations, {
                courseRegistrationCode: code
            });
        }

        function getByRegistrationId(registrationId) {
            return repositorySvc.customGet('getByRegistrationId', CourseRegistrations, {
                courseRegistrationId: registrationId
            });
        }


        function getRegisteredAttendanceForCourse(courseID) {
            var registrations = getAllForCourse(courseID);
            var deferred = $q.defer();
            var result = [];

            registrations.$promise.then(function (data) {
                angular.forEach(data, function (registration) {
                    result.push({
                        studentID: registration.studentID,
                        fullName: registration.studentFullName,
                        attendanceStatus: 0,
                        attendanceType: 0,
                        attendanceCount: 1
                    });
                });
                deferred.resolve(result);
            }, function (errorResult) {
                deferred.reject(errorResult);
            });

            result.$promise = deferred.promise;
            return result;
        }

        function sendRegistrationNotification(courseRegistrationID) {
            return $q(function (resolve, reject) {
                CourseRegistrations.sendRegistrationNotification(
                    { courseRegistrationID: courseRegistrationID },
                    function (successResult) {
                        notificationSvc.notifyInfo($translate.instant('TXT_ALERT_TITLE_NOTIFICATION_SENT'));
                        resolve(successResult);
                    }, function (errorResult) {
                        repositorySvc.defaultErrorHandler(errorResult);
                        reject(errorResult);
                    });
            });
        }

        function insertAll(data, courseID, notificationSetting, subjectCategory, successCallback, errorCallback) {
            repositorySvc.customPost(
                "insertAll",
                CourseRegistrations,
                {
                    models: {
                        model: data,
                        courseID: courseID
                    },
                    subjectCategory: subjectCategory,
                    sendEmailNotification: notificationSetting.sendEmailNotification,
                    sendSmsNotification: notificationSetting.sendSmsNotification
                },                        // entity
                successCallback,
                function (errorResult) {
                    notificationSvc.notifyError(
                        $translate.instant('TXT_ALERT_TITLE_CHANGES_SAVE_ERROR'),
                        notificationSvc.translateError(errorResult));

                    if (errorCallback) {
                        errorCallback(errorResult);
                    }
                });
        }

        function createFullCourseInterest(students, course, classroom) {
            return $q(function (resolve, reject) {
                var promisses = [];

                _.forEach(students, function (student) {
                    var request = {
                        userId: student.parentID,
                        studentId: student.studentID,
                        courseId: course.courseID,
                        semesterId: course.semesterID,
                        subjectId: course.subjectID,
                        classroomId: course.classroomID,
                        teacherId: course.employeeID,
                        courseName: course.name,
                        courseAbbreviation: course.abbreviation,
                        courseFullName: courseSvc.getCourseFullName(course),
                        courseStartDate: course.firstLesson,
                        courseEndDate: course.lastLesson,
                        subjectName: course.subjectName,
                        classroomName: classroom.name,
                        teacherFullName: course.teacher,
                        notes: student.notes,
                    }

                    promisses.push(repositorySvc.customPost(
                        'createFullCourseInterest',
                        CourseRegistrations,
                        request,
                        null,
                        null,
                        true).$promise);
                });

                $q.all(promisses).then(resolve, reject);
            });
        }

        function insert(data, notificationSetting, subjectCategory, successCallback, errorCallback) {
            repositorySvc.insert(
                CourseRegistrations,      // $resource
                null,                     // collection
                {
                    model: data,
                    subjectCategory: subjectCategory,
                    sendEmailNotification: notificationSetting.sendEmailNotification,
                    sendSmsNotification: notificationSetting.sendSmsNotification
                },                        // entity
                successCallback,
                errorCallback);
        }

        function update(data, notificationSetting, subjectCategory, updateInvoice, successCallback, errorCallback) {
            repositorySvc.update(
                CourseRegistrations,                   // $resource
                null,                                  // collection
                {
                    model: data,
                    subjectCategory: subjectCategory,
                    updateInvoice: updateInvoice || false,
                    sendEmailNotification: notificationSetting.sendEmailNotification,
                    sendSmsNotification: notificationSetting.sendSmsNotification
                },                                // entity
                successCallback,
                errorCallback);
        }

        function remove(data, subjectCategory, successCallback, errorCallback) {
            repositorySvc.remove(
                CourseRegistrations,                            // $resource
                null,                    // collection
                {
                    courseRegistrationID: data.courseRegistrationID,
                    subjectCategory: subjectCategory
                },           // entity
                successCallback,
                errorCallback,
                {
                    courseRegistrationID: data.courseRegistrationID,
                    subjectCategory: subjectCategory
                });
        }
        
        function calcExpectedDueDate(courseId, registrationDate) {
            return repositorySvc.customPost(
                'calcExpectedDueDate',
                CourseRegistrations,
                { courseId: courseId, issueDate: registrationDate },
                null,
                null,
                true);
        }

        return {
            getAllForCourse: getAllForCourse,
            getAllForCourseAndUser: getAllForCourseAndUser,
            getRegisteredAttendanceForCourse: getRegisteredAttendanceForCourse,
            getAllCoursesByStudent: getAllCoursesByStudent,
            getAllActionsByStudent: getAllActionsByStudent,
            getAllCoursesByUser: getAllCoursesByUser,
            getAllActionsByUser: getAllActionsByUser,
            getInfoFromCourseRegistrationBarcode: getInfoFromCourseRegistrationBarcode,
            sendRegistrationNotification: sendRegistrationNotification,
            createNew: createNew,
            initializeModel: initializeModel,
            insert: insert,
            insertAll: insertAll,
            update: update,
            remove: remove,
            updateReservedPlaces: updateReservedPlaces,
            refreshSchedules: refreshSchedules,
            createFullCourseInterest: createFullCourseInterest,
            calcExpectedDueDate: calcExpectedDueDate,
            getCourseInterestById: getCourseInterestById,
            getByRegistrationId: getByRegistrationId
        }
    }
]);
